import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import ConfigService from "./services/ConfigService";
import ElectronService from "./services/ElectronService";
import EventsService from "./services/EventsService";
import "./index.css";

// scroll bar
import "simplebar/src/simplebar.css";

import { HelmetProvider } from "react-helmet-async";
import AlertDialog from "./components/AlertDialog.jsx";
import ErrorBoundary from "./ErrorBoundary.jsx";
import Telemetry from "@poriyaalar/telemetry";
import WebSocket from "./components/WebSocket.jsx";

if (import.meta.env.VITE_APP_ENV === "production") {
  const TelemetryService = new Telemetry({
    sentry: {
      dsn: "https://80b9b8e341ec4ae928f3d7340ed1391e@o4507809692712960.ingest.de.sentry.io/4508883711557712",
      environment: import.meta.env.VITE_APP_ENV,
      tracePropagationTargets: [/^https:\/\/consumer\.positeasy\.in\//],
      tracesSampleRate: 0,
    },
  });
  window.telemetry = TelemetryService;
}

if (window.mainAPI) {
  console.log = (args, data) => {
    window.mainAPI.log("log", { args, data });
  };
}

EventsService.boot(() => {
  ConfigService.boot(() => {
    ReactDOM.createRoot(document.getElementById("root")).render(
      <React.StrictMode>
        <HelmetProvider>
          <BrowserRouter>
            <ErrorBoundary>
              <App />
              <WebSocket />
            </ErrorBoundary>
            <AlertDialog />
          </BrowserRouter>
        </HelmetProvider>
      </React.StrictMode>
    );
  });
});

window.ElectronService = ElectronService;
